import React from "react";
import styled from "styled-components";
import {GreenButton} from "./ButtonStyles";

const SendMessageButton = () => {
    return(
        <Button type="submit">
            <p> Envoyer un message </p>
        </Button>
    )
}


const Button = styled(GreenButton)`
  padding: 1rem;
`
export default SendMessageButton;